export interface AlertSettings {
    position: 'top' | 'bottom';
    useAnimation: boolean;
    opacity: number;
    duration: number;
}

interface IDocumentSettings {
    booleanSettings: IBooleanSettings[];
}

interface IBooleanSettings {
    name: string;
    state: boolean;
    label: string;
}

export interface IDocumentStore {
    name: StoreNameEnum;
    fieldName?: string;
    value: string[];
}

export enum StoreNameEnum {lastSearchQuery = 'lastSearchQuery'}

export interface DocumentTabSettings {
    enabledFields: string[]; // ID полей, которые доступны для таба
    tabOrder: string[]; // Порядок табуляции
    autoSkipDisabled: boolean; // Автоматически пропускать отключенные поля
    documentSettings?: IDocumentSettings;
    documentStore?: IDocumentStore[];
}

export interface DocumentSettings {
    invoiceItemCreator: DocumentTabSettings;
    // другие документы...
}

export interface UISettings {
    alerts: AlertSettings;
    documents: DocumentSettings;
    tabBehavior: {
        cycle: boolean; // Циклическое перемещение
        rememberLastField: boolean; // Запоминать последнее активное поле
    };
}
